import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListCityRequest extends IBaseRequest {
    limit?:       string;
    offset?:      string;
    countOnly?:   string;
    orderByType?: string;
    orderBy?:     string;
    zipName?:     string;
    zipId?:       string;
    cityName?:    string;
    cityId?:      string;
    regionName?:  string;
    regionId?:    string;
    countryName?: string;
    countryId?:   string;
}

export class ListCityRequest extends BaseRequest implements IListCityRequest {
    public limit?: string;
    public offset?: string;
    public countOnly?: string;
    public orderByType?: string;
    public orderBy?: string;
    public zipName?: string;
    public zipId?: string;
    public cityName?: string;
    public cityId?: string;
    public regionName?: string;
    public regionId?: string;
    public countryName?: string;
    public countryId?: string;
    

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.limit = otherOptions.limit;
    this.offset = otherOptions.offset;
    this.countOnly = otherOptions.countOnly;
    this.orderByType = otherOptions.orderByType;
    this.orderBy = otherOptions.orderBy;
    this.zipName = otherOptions.zipName;
    this.zipId = otherOptions.zipId;
    this.cityName = otherOptions.cityName;
    this.cityId = otherOptions.cityId;
    this.regionName = otherOptions.regionName;
    this.regionId = otherOptions.regionId;
    this.countryName = otherOptions.countryName;
    this.countryId = otherOptions.countryId;
  }


  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.limit, 'limit');   
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.countOnly, 'countOnly');
    parameters += this.makeNode(this.orderByType, 'orderByType');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.zipName, 'zipName');
    parameters += this.makeNode(this.zipId, 'zipId');
    parameters += this.makeNode(this.cityName, 'cityName');
    parameters += this.makeNode(this.cityId, 'cityId');
    parameters += this.makeNode(this.regionName, 'regionName');
    parameters += this.makeNode(this.regionId, 'regionId');
    parameters += this.makeNode(this.countryName, 'countryName');
    parameters += this.makeNode(this.countryId, 'countryId');
    
    return super.wrapperXml('ListCity', parameters);
  }
}
